import React, { Component } from 'react'
import css from './style.css'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import JewelryCartItems from './jewelry-cart-items'
import DiamondCartItems from './diamond-cart-items'
import CartSummary from './cart-summary'
import EmptyCart from './empty-cart'
import * as actions from '../../actions/cart'

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.cart,
    cartVisible: state.settings.cartVisible
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setDepositRates: () => {
      dispatch(actions.setDepositRates())
    }
  }
}

export class Cart extends Component {
  componentWillMount () {
    this.props.setDepositRates()
  }

  getClassNames () {
    return [
      css.container,
      this.props.cartVisible ? '' : css.hide
    ].join(' ')
  }

  emptyCart () {
    return !(this.hasDiamonds() || this.hasJewelry())
  }

  hasJewelry () {
    return Object.keys(this.props.jewelry).length > 0
  }

  hasDiamonds () {
    return Object.keys(this.props.diamonds).length > 0
  }

  render () {
    return (
      <div id='cart-container' className={this.getClassNames()}>
        {this.emptyCart() && <EmptyCart />}
        {this.hasJewelry() && <JewelryCartItems />}
        {this.hasDiamonds() && <DiamondCartItems />}
        {!this.emptyCart() && <CartSummary />}
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Cart))



// WEBPACK FOOTER //
// ./src/containers/cart/index.js